import { Badge } from '~/shared/components/Badge';
import { DataTable } from '~/shared/data-tables/DataTable';
import type { DiagnosisModel } from './types';
import type { DataTableColumnProps } from '~/shared/data-tables/DataTableColumn';

const columns: DataTableColumnProps<DiagnosisModel>[] = [
	{
		key: 'code',
		header: 'ICD',
		width: 'w-24',
		renderCell: d => (
			<div className="flex items-center gap-1.5">
				<span className="font-mono text-xs font-semibold text-gray-800">{d.icdDiagnosis.code}</span>
				{d.order === 1 && <Badge intent="success">Primary</Badge>}
			</div>
		)
	},
	{
		key: 'description',
		header: 'Description',
		cellClassName: 'text-sm text-gray-800',
		renderCell: d => d.icdDiagnosis.description
	},
	{
		key: 'symptomControlRatingLabel',
		header: 'SCR',
		whitespaceNowrap: true,
		cellClassName: 'text-xs text-gray-500',
		renderCell: d => d.symptomControlRatingLabel.split(' - ')[0] // Show only the rating number, not the full label
	},
	{
		header: 'Onset Date',
		key: 'onsetDate',
		renderCell: d => (d.onsetDate ? new Date(d.onsetDate).toLocaleDateString() : 'N/A')
	}
];

export function DiagnosesTable({ rows }: { rows: DiagnosisModel[] }) {
	const sorted = rows.toSorted((a, b) => a.order - b.order);
	return (
		<DataTable
			columns={columns}
			rows={sorted}
			viewMore={{
				text: 'View Additional Diagnoses',
				threshold: 10
			}}
			getRowNotes={x => x.notes ?? null}
			getRowId={x => x.icdDiagnosisId}
		/>
	);
}
